module.exports = __webpack_public_path__ + "static/media/onboarding-hasAccount.3fa6f184.png";